import { SeuIndustryType } from '@seu-types';
import { neverError } from './never.helper';

export function getIndustryLabel(type: SeuIndustryType): string {
  switch (type) {
    case 'metal':
      return 'global.industries.metal';
    case 'glass':
      return 'global.industries.glass';
    case 'ligno':
      return 'global.industries.ligno';
    case 'ercs':
      return 'global.industries.ercs';
    case 'energy':
      return 'global.industries.energy';
    case 'panels':
      return 'global.industries.panels';
    case 'imi':
      return 'global.industries.imi';
    default:
      neverError(type);
  }
}
